import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { UncontrolledTooltip } from 'reactstrap';

import { ReactComponent as ClearIcon } from 'assets/icon-close-round.svg';

import { ButtonIcon } from 'shared/components/Buttons';
import { colors } from 'shared/defaultTheme';
import { IconProp } from 'shared/prop-types/ReducerProps';

import { AttachmentBoxWrapper } from './styles';

const AttachmentBox = ({ className, icon, name, remove, index, isRemove, onDownload }) => {
  const { t } = useTranslation();
  return (
    <AttachmentBoxWrapper className={className} onClick={onDownload}>
      <div className="chip-name-container" id={`attachment-name-${index}`}>
        <div className="ml-1">{icon}</div>
        <span className="chip-name ml-1">{name}</span>
        <UncontrolledTooltip placement="top" target={`attachment-name-${index}`} flip>
          {name ?? ''}
        </UncontrolledTooltip>
      </div>
      {isRemove && (
        <ButtonIcon
          id="refres-icon-notification"
          title={t('documents_delete')}
          type="button"
          Icon={() => <ClearIcon fill={colors.suvaGrey} />}
          className="button-icon"
          onClick={remove}
        />
      )}
    </AttachmentBoxWrapper>
  );
};

AttachmentBox.defaultProps = {
  className: '',
  name: '',
  remove: undefined,
  index: 0,
  isRemove: true,
  onDownload: () => null,
};

AttachmentBox.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  icon: IconProp.isRequired,
  remove: PropTypes.func,
  index: PropTypes.number,
  isRemove: PropTypes.bool,
  onDownload: PropTypes.func,
};

export default AttachmentBox;
